import React, { Component } from 'react';
import * as networkHelpers from '../../../../../helpers/networkHelpers';
import PropTypes from 'prop-types';

class PromoModalTitleProduct extends Component {
    render() {
        const { name, network } = this.props, networkLetters = networkHelpers.setCurrentNetwork( network );
        const networkTitle = networkHelpers.setNetworkTitle( networkLetters );

        return (
            <div className="promos-page-header">
                <h2 classname="h2">{ name }</h2>
                <h3 className="h3 advantage">Take advantage of</h3>
                <h4 className="h4 personal-offer">YOUR PERSONAL OFFER</h4>
                <h3 className="h3 title-lines"><span>From</span></h3>
                <h3 className="h3 brand-color">{ networkTitle }</h3>
            </div>
        );
    }
}

PromoModalTitleProduct.propTypes = {
    name: PropTypes.string.isRequired,
    network: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
};

export default PromoModalTitleProduct;



// WEBPACK FOOTER //
// src/client/components/site/features/promos/elements/PromoModalTitleProduct.js